export default __webpack_public_path__ + "static/media/mini-3.3a70121c.jpg";